import React, { useState } from "react";
import "./SidebarContainer.css";
import { motion } from "framer-motion";
import {
  authenticateUser,
  storeUserDetails,
} from "../../redux/slices/authSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store/store";

const SidebarContainer: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userName = useSelector((state: RootState) => state?.auth.userDetails);
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const logoutHandler = () => {
    dispatch(authenticateUser(""));
    dispatch(storeUserDetails(""));
    setIsOpen(!isOpen);
  };

  const homeHandler = () => {
    navigate("/home");
    setIsOpen(!isOpen);
  };

  return (
    <div className="menu-container">
      {/* Hamburger Icon */}
      <button className="hamburger" onClick={() => setIsOpen(!isOpen)}>
        <motion.div
          animate={{ rotate: isOpen ? 45 : 0, y: isOpen ? 8 : 0 }}
          className="line"
        />
        <motion.div animate={{ opacity: isOpen ? 0 : 1 }} className="line" />
        <motion.div
          animate={{ rotate: isOpen ? -45 : 0, y: isOpen ? -8 : 0 }}
          className="line"
        />
      </button>
      
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, x: 0, y: -50 }} // Start from right (outside screen)
          animate={{ opacity: 1, x: 0, y: -30 }} // Move to normal position
          exit={{ opacity: 0, x: 0, y: -50  }} // Exit animation
          transition={{ duration: 0.3, ease: 'easeIn' }}
          className="absolute top-0 right-0 mt-2 w-48 bg-white border border-gray-300 shadow-lg rounded-lg"
        >
          <div className="profile-popup">
            {/* <div className="slide-container"> */}
            <h3>{`Welcome, ${userName.name}`}</h3>
            {/* <button onClick={homeHandler} className="logout-button">
              <i className="fa-solid fa-house"></i>
              <span>Home</span>
            </button> */}
            <button onClick={logoutHandler} className="logout-button">
              {/* <img alt="exit" src={require("../../assets/images/exit.png")} /> */}
              <i className="fa-solid fa-right-from-bracket"></i>
              <span>Logout</span>
            </button>
            {/* </div> */}
          </div>
        </motion.div>
      )}

      {/* Animated Menu */}
      {/* <motion.div
        initial={{ x: "-100%" }}
        animate={isOpen ? { x: 0 } : { x: "-100%" }}
        transition={{ duration: 0.4 }}
        className="menu"
      >
        <div className="slide-container">
          <button className="logout">
            <p>Logout</p>
          </button>
        </div>
      </motion.div> */}
    </div>
  );
};

export default SidebarContainer;
